import BaseBoosterBehavior, { IBaseBoosterBehaviorPlayMeta } from './BaseBoosterBehavior';
import CardStateHelper, { isCardTypeJoker } from '../CardStateHelper';
import { CardType } from 'Prototype/Level/Card/CardType';
import { Random } from 'Utility/Random';
import { DEFAULT_CARD_HEIGHT, DEFAULT_CARD_WIDTH } from 'Prototype/Level/Card/ICardData';
import { CardTask } from '../CardTasks';
import { BoosterType } from '../BoosterType';
import { track, TrackMethod } from 'Utility/Tracking/Track';
import { TransactionType } from 'Utility/Tracking/DataSet/Transaction';
import { IGameState } from '../../Game/IGameState';
import { initialCardStateData } from '../initialCardStateData';
import { Quests } from '../../Player/QuestType';
import { InventoryStateHelper } from 'State/Player/Inventory/InventoryStateHelper';
import { isNearEndGame } from 'State/Level/LevelStateHelper';
import { QuestStateHelper } from 'State/Player/Quests/QuestStateHelper';

export default class JokerBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState, meta?: IBaseBoosterBehaviorPlayMeta): IGameState {
        let cardsState = {
            ...state.levelState.cardsState,
        };

        const newCardID = `card_joker_${Random.ID()}`;

        cardsState = CardStateHelper.addCard(cardsState, {
            ...initialCardStateData,
            id: newCardID,
            type: CardType.joker,
            faceUp: false,
            sequence: 0,
            modifiers: [],
            attempts: 0,
            x: 500,
            y: 0,
            rotation: 0,
            depth: 0,
            width: DEFAULT_CARD_WIDTH,
            height: DEFAULT_CARD_HEIGHT,
        });

        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.JOKER,
            cards: [newCardID],
        });

        cardsState = CardStateHelper.setJokerCardFolded(cardsState, newCardID);

        // Clear the undo history when a joker is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState: cardsState,
            },
        };

        state = this.incrementBoosterUse(state, BoosterType.JOKER);

        return this.consumeItemOrCoins(state);
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices[BoosterType.JOKER];
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory[BoosterType.JOKER];
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        track('transactionType', TransactionType.INVENTORY);

        // TODO: use InventoryStateHelper.consumeInventory instead
        return {
            ...state,
            playerState: InventoryStateHelper.setBoosterJoker(
                state.playerState,
                state.playerState.inventory[BoosterType.JOKER] - 1,
                { queueTask: false }
            ),
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        super.trackCoinsSpent(state, 'tJokerCoins');
        track('tJokerReceived', 1, TrackMethod.ADD);
        state = super.spendCoins(state);
        track('tJokerUsed', 1, TrackMethod.ADD);
        return state;
    }

    /**
     * Ensure that the current card is not already a joker.
     * @param state
     */
    public isPlayable(state: IGameState): boolean {
        const topCardID = CardStateHelper.getCurrentCard(state.levelState.cardsState);
        const topCard = state.levelState.cardsState.cards[topCardID];

        return super.isPlayable(state) && !isCardTypeJoker(topCard?.type);
    }

    protected consumeItemOrCoins(state: IGameState): IGameState {
        track('mJokerUsed', 1, TrackMethod.ADD);

        if (isNearEndGame(state)) {
            track('mNumBoostersUsedLossAversion', 1, TrackMethod.ADD);
        }

        let newState = {
            ...state,
            playerState: QuestStateHelper.incrementQuestProgressBy(state.playerState, Quests.USE_JOKERS, 1),
        };
        return super.consumeItemOrCoins(newState);
    }
}
